import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { useStockUnit } from "../hooks";
import { QrCodeImage, ExitStockUnitForm } from "../components";
import { StockScansList } from "../../stock-scans/components";
import { stockExitReasonLabel } from "../../../helpers/enum-labels";

type IStockUnitParams = {
  id: string;
};

export const StockUnit: React.FC = () => {
  const { id } = useParams<IStockUnitParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading, refetch } = useStockUnit(+id!);

  if (loading) return <Loading />;

  const unit = data?.stockUnit?.result;

  return (
    <>
      <Header title="Lot" subtitle={unit?.batchNumber} />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Produit</p>
                    <input className="input w-full" value={unit?.product?.name} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Entrepôt</p>
                    <input className="input w-full" value={unit?.warehouse?.name} disabled />
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Quantité</p>
                    <input className="input w-full" value={unit?.quantity} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Statut</p>
                    <input
                      className="input w-full"
                      value={unit?.exitedAt ? `Sorti (${stockExitReasonLabel(unit.exitReason)})` : "En stock"}
                      disabled
                    />
                  </div>
                </div>
              </div>
              {unit?.exitedAt && unit?.issueComment && (
                <div className="w-full mt-3">
                  <p className="label">Commentaire</p>
                  <textarea className="input w-full" value={unit.issueComment} disabled rows={2} />
                </div>
              )}
            </div>

            {unit && !unit.exitedAt && (
              <div className="card mt-4">
                <CardHeader title="Sortie de stock" />
                <ExitStockUnitForm stockUnitId={+id!} onCompleted={refetch} />
              </div>
            )}
          </div>

          <div className="element">
            <div className="card flex flex-col items-center gap-3 py-6">
              <CardHeader title="QR code" />
              {unit?.qrCode?.code && <QrCodeImage value={unit.qrCode.code} />}
              <p className="text-xs text-gray-500">{unit?.qrCode?.code}</p>
            </div>

            <div className="card mt-4">
              <CardHeader title="Historique des scans" />
              <StockScansList stockUnitId={+id!} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
